import React from 'react';
import { Heart, Search, UserCheck } from 'lucide-react';
export function WhyChooseUs() {
  return <section id="why-us" className="py-24 bg-white" data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <div className="text-center mb-16" data-id="element-139">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-140">
            Why beginners choose Playcraft
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-141">
            We are not a traditional bank. We are your local partners in
            financial education.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-142">
          <div className="bg-gray-50 rounded-3xl p-8 text-center hover:bg-emerald-50 transition-colors duration-300" data-id="element-143">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white shadow-sm mb-6 text-emerald-600" data-id="element-144">
              <Heart className="h-8 w-8" data-id="element-145" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-146">
              Beginner-Focused
            </h3>
            <p className="text-gray-600" data-id="element-147">
              No jargon, no judgment. We explain everything in plain
              Polish/English until you feel 100% comfortable.
            </p>
          </div>

          <div className="bg-gray-50 rounded-3xl p-8 text-center hover:bg-emerald-50 transition-colors duration-300" data-id="element-148">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white shadow-sm mb-6 text-emerald-600" data-id="element-149">
              <Search className="h-8 w-8" data-id="element-150" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-151">
              Transparent Fees
            </h3>
            <p className="text-gray-600" data-id="element-152">
              We charge a flat fee in PLN. No hidden commissions or surprise
              charges. You always know what you pay.
            </p>
          </div>

          <div className="bg-gray-50 rounded-3xl p-8 text-center hover:bg-emerald-50 transition-colors duration-300" data-id="element-153">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white shadow-sm mb-6 text-emerald-600" data-id="element-154">
              <UserCheck className="h-8 w-8" data-id="element-155" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-156">
              Personalized Support
            </h3>
            <p className="text-gray-600" data-id="element-157">
              You get a dedicated consultant who knows your name and your goals,
              not just an account number.
            </p>
          </div>
        </div>

        <div className="mt-16 bg-emerald-600 rounded-3xl p-8 md:p-12 text-center text-white relative overflow-hidden" data-id="element-158">
          <div className="absolute top-0 left-0 w-full h-full opacity-10" data-id="element-159">
            <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-160">
              <path d="M0 100 C 20 0 50 0 100 100 Z" fill="white" data-id="element-161" />
            </svg>
          </div>

          <div className="relative z-10" data-id="element-162">
            <h3 className="text-3xl font-bold mb-6" data-id="element-163">
              Ready to start your journey?
            </h3>
            <p className="text-emerald-100 text-lg mb-8 max-w-2xl mx-auto" data-id="element-164">
              Book your free 30-minute consultation today. No commitment
              required.
            </p>
            <button className="bg-white text-emerald-600 hover:bg-emerald-50 px-8 py-4 rounded-full font-bold text-lg transition-colors shadow-lg" data-id="element-165">
              Schedule Free Consultation
            </button>
          </div>
        </div>
      </div>
    </section>;
}